/**
 * Textos del modal «Cargar Declaración Jurada» cuando se abre desde la grilla
 * Mis cuentas (PBI 81147, D8). Se pasan por la prop `textos` de ModalDdjj, así
 * que no modifican los textos por defecto del banner del Shell (MODAL_CARGA_DDJJ).
 * Las reglas de validación (solo PDF, 2 MB) van por la prop `validacion`.
 */
export const TEXTOS_DDJJ_MIS_CUENTAS = {
  bajada: 'Adjuntá el formulario firmado por el responsable médico',
  alerta:
    'Sin la Declaración Jurada no podés acceder a todas las funcionalidades.\nUna vez subido el documento, el administrador lo verificará.',
  hintFormato: 'Admite solo archivo PDF',
  hintTamanio: 'El archivo debe ser menor a 2 MB.',
  exito: 'Se envió el archivo exitosamente. Cuando Provincia ART lo verifique, serás notificado.',
  errorGenerico: 'Ocurrió un error al enviar el archivo. Intentá nuevamente más tarde.',
}

/**
 * Reglas de validación del archivo para la carga desde Mis cuentas: solo PDF, hasta 2 MB.
 */
export const VALIDACION_DDJJ_MIS_CUENTAS = {
  maxBytes: 2 * 1024 * 1024,
  extensiones: ['.pdf'],
}
